module.exports = __webpack_public_path__ + "img/ogg.ea0938ed.svg";